import { useState, useEffect } from 'react';
import { api } from '../api';
import { useApp } from '../contexts/AppContext';

export default function ChatScopeBanner({ caseId }) {
  const { chatScope, dispatch } = useApp();
  const [loading, setLoading] = useState(true);

  // Load scope on mount
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await api.get(`/exploration/case/${caseId}/chat-scope`);
        if (!cancelled && data?.label) {
          dispatch({ type: 'SET_CHAT_SCOPE', scope: data });
        }
      } catch {
        // no scope set
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [caseId, dispatch]);

  async function handleClear() {
    try {
      await api.del(`/exploration/case/${caseId}/chat-scope`);
      dispatch({ type: 'CLEAR_CHAT_SCOPE' });
    } catch {
      // ignore
    }
  }

  if (loading || !chatScope?.label) return null;

  const docCount = chatScope.document_ids?.length || 0;
  const folderCount = chatScope.folder_paths?.length || 0;
  const isRefine = chatScope.kind === 'refine';

  return (
    <div className="chat-scope-banner">
      <span className="scope-icon">{isRefine ? '✨' : '🎯'}</span>
      <span className="scope-text">
        {isRefine ? 'Refining: ' : 'Scoped to: '}<strong>{chatScope.label}</strong>
        {!isRefine && docCount > 0 && ` (${docCount} doc${docCount > 1 ? 's' : ''})`}
        {!isRefine && folderCount > 0 && ` (${folderCount} folder${folderCount > 1 ? 's' : ''})`}
      </span>
      <button className="btn-ghost btn-sm" onClick={handleClear} title="Clear scope">✕</button>
    </div>
  );
}
